import React, { useState, useEffect, useCallback } from 'react';
import ReadContentsSection from './Read-table-content';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const Stickysidebar = ({ featuredPodcast, featuredVideo, ReadItemTableContent, hasAboutAuthor = false }) => {
  const hasVideo = Boolean(featuredVideo?.text?.trim());
  const hasPodcast = Boolean(featuredPodcast);

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia('(max-width: 991px)').matches;
    }
    return false;
  });

  const [activeItem, setActiveItem] = useState('video');
  const [isSidebarVisible, setIsSidebarVisible] = useState(() => {
    if (typeof window !== 'undefined') {
      return !window.matchMedia('(max-width: 991px)').matches;
    }
    return true;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 991px)');
    const updateIsMobile = () => {
      setIsMobile(mediaQuery.matches);
      if (!mediaQuery.matches || activeItem !== 'article') {
        setIsSidebarVisible(!mediaQuery.matches);
      }
    };

    mediaQuery.addEventListener('change', updateIsMobile);
    return () => mediaQuery.removeEventListener('change', updateIsMobile);
  }, [activeItem]);

  const handleItemClick = (id) => {
    if (activeItem === id) {
      setActiveItem(''); // Turn off active item if clicked again
      return;
    }
    setActiveItem(id);

    if (typeof window !== 'undefined') {
      window.history.pushState(null, '', `${window.location.pathname}#${id}`);
      document.getElementById(id)?.scrollIntoView();
    }

    // On mobile, close sidebar for all items except 'article'
    if (isMobile && id !== 'article') {
      setIsSidebarVisible(false);
    }
  };

  const handleClickOutside = useCallback(
    (event) => {
      const sidebar = document.querySelector('.sidebar-readpage');
      if (sidebar && !sidebar.contains(event.target) && isSidebarVisible) {
        setIsSidebarVisible(false);
      }
    },
    [isSidebarVisible]
  );

  useEffect(() => {
    if (isMobile && typeof document !== 'undefined') {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isMobile, handleClickOutside]);

  const toggleSidebar = () => setIsSidebarVisible((prev) => !prev);

  const items = [
    ...(hasVideo ? [{ id: 'video', label: 'Video' }] : []),
    { id: 'article', label: 'Article', children: ReadItemTableContent },
    ...(hasPodcast ? [{ id: 'podcast', label: 'Podcast' }] : []),
    ...(hasAboutAuthor ? [{ id: 'about-author', label: 'About the Author' }] : []),
    { id: 'references', label: 'References' },
  ];

  return (
    <div className="site-read-wrapper sidebar-section-readpage">
      <div className={`sidebar-readpage  ${!isSidebarVisible ? 'sidebar-readpage-hidden' : ''}`}>
        <nav className={`sidebar-readpage__nav  ${!isSidebarVisible && 'w-0'}`}>
          <div onClick={toggleSidebar} className="arrow-rect">
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
              <path d="M0.628906 4.49994L5.85849 0.655312L5.85849 8.34457L0.628906 4.49994Z" fill="#0A0A0A" />
            </svg>
          </div>
          <div className={`sidebar-contents ${isSidebarVisible ? '' : 'sidebar-nav-hidden w-0'}`}>
            <h2 className="sidebar-readpage__header">SECTIONS</h2>
            <ul className="sidebar-readpage__list">
              {items.map((item) => (
                <React.Fragment key={item.id}>
                  <li
                    key={item.id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                    className={`sidebar-readpage ${activeItem === item.id ? 'sidebar-readpage__item--active' : ''}`}
                    onClick={() => handleItemClick(item.id)}
                  >
                    {item.label}
                    {item.children && item.children.length > 0 && (
                      <KeyboardArrowDownIcon
                        style={{
                          width: 20,
                          height: 20,
                          color: 'white',
                          marginRight: '30px',
                          transition: 'transform 0.3s ease',
                          transform: activeItem === item.id ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </li>

                  {item.children && item.children.length > 0 && activeItem === 'article' && (
                    <ReadContentsSection items={ReadItemTableContent} />
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Stickysidebar;
